module.exports = __webpack_public_path__ + "img/madjam.df1a036f.png";